import { axiosGet, axiosPost } from "../../react_axios/Axios"
import {
    DELETE_CMS_MENU_ACTION_TYPE, DELETE_CMS_STATIC_FILES_ACTION_TYPE, deleteCMSMenuUrl, deleteCMSStaticFilesUrl,
    GET_CMS_CONTENT_ACTION_TYPE, getCmsContentUrl, headers, insertUpdateCMSStaticUploadsUrl, IU_CMS_BANNER_ACTION_TYPE,
    IU_CMS_CONTENT_ACTION_TYPE, IU_CMS_CONTENT_SECTION_ACTION_TYPE, IU_CMS_FOOTER_ACTION_TYPE, IU_CMS_MENU_ACTION_TYPE,
    IU_CMS_STATIC_UPLOADS_ACTION_TYPE, IU_CMS_SUBHEADER_ACTION_TYPE, IUCmsBannerUrl, IUCmsContentSectionUrl, IUCmsContentUrl,
    IUCmsFooterUrl, IUCmsMenuUrl, IUCmsSubheaderUrl, PUBLISH_CMS_BANNER_ACTION_TYPE, PUBLISH_CMS_CONTENT_ACTION_TYPE,
    PUBLISH_CMS_FOOTER_ACTION_TYPE, PUBLISH_CMS_MENU_ACTION_TYPE, PUBLISH_CMS_SUBHEADER_ACTION_TYPE, PublishCmsBannerUrl,
    PublishCmsContentUrl, PublishCmsFooterUrl, PublishCmsMenuUrl, PublishCmsSubheaderUrl, UPDATE_CMS_CONTENT_STATUS_ACTION_TYPE,
    updateCMSContentStatusUrl,
} from "../../utils/constants"
export const getCmsContent_action = (MenuID, MenuUrl) => async (dispatch) => {
    try {
        const mapdata = { UserID: sessionStorage.getItem('UserIDSS'), MenuID: MenuID, MenuUrl: MenuUrl }
        const res = await axiosGet(getCmsContentUrl, mapdata, headers);
        dispatch({
            type: GET_CMS_CONTENT_ACTION_TYPE,
            payload: res,
        });
        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const insertUpdateCmsContent_action = (sectionData) =>
    async (dispatch) => {
        try {
            const mapdata = {
                UserID: sessionStorage.getItem('UserIDSS'),
                sectionData: sectionData
            };
            const res = await axiosPost(IUCmsContentUrl, mapdata, headers);
            dispatch({
                type: IU_CMS_CONTENT_ACTION_TYPE,
                payload: res,
            });
            return Promise.resolve(res);
        } catch (err) {
            return Promise.reject(err);
        }
    };

export const insertUpdateCmsContentSection_action = (ContentID, MenuID, SeqNo, isFixed, isEdit, SectionContent, isPublish, isactive) =>
    async (dispatch) => {
        try {
            const mapdata = {
                UserID: sessionStorage.getItem('UserIDSS'),
                ContentID: ContentID, MenuID: MenuID, SeqNo: SeqNo, isFixed: isFixed, isEdit: isEdit,
                SectionContent: SectionContent, isPublish: isPublish, isactive: isactive
            };
            const res = await axiosPost(IUCmsContentSectionUrl, mapdata, headers);
            dispatch({
                type: IU_CMS_CONTENT_SECTION_ACTION_TYPE,
                payload: res,
            });
            return Promise.resolve(res);
        } catch (err) {
            return Promise.reject(err);
        }
    };
export const insertUpdateCmsMenu_action = (menuData) =>
    async (dispatch) => {
        try {
            const mapdata = {
                UserID: sessionStorage.getItem('UserIDSS'),
                menuData: menuData
            };
            const res = await axiosPost(IUCmsMenuUrl, mapdata, headers);
            dispatch({
                type: IU_CMS_MENU_ACTION_TYPE,
                payload: res,
            });
            return Promise.resolve(res);
        } catch (err) {
            return Promise.reject(err);
        }
    };

export const insertUpdateCmsFooter_action = (cmsFooterData) =>
    async (dispatch) => {
        try {
            const mapdata = {
                UserID: sessionStorage.getItem('UserIDSS'),
                FooterID: cmsFooterData.FooterID,
                SeqNo: 1,
                FooterContent: cmsFooterData.FooterContent,
                isPublish: cmsFooterData.isPublish,
                isActive: cmsFooterData.isActive
            };
            const res = await axiosPost(IUCmsFooterUrl, mapdata, headers);
            dispatch({
                type: IU_CMS_FOOTER_ACTION_TYPE,
                payload: res,
            });
            return Promise.resolve(res);
        } catch (err) {
            return Promise.reject(err);
        }
    };
export const insertUpdateCmsBanner_action = (BannerID, BannerFilepath, formFileType, FileName, FormFile, isPublish, isActive) =>
    async (dispatch) => {
        try {
            const mapdata = {
                UserID: sessionStorage.getItem('UserID'),
                BannerID: BannerID,
                BannerFilepath: BannerFilepath,
                formFileType: formFileType,
                FileName: FileName,
                FormFile: FormFile,
                isPublish: isPublish,
                isActive: isActive
            };
            const res = await axiosPost(IUCmsBannerUrl, mapdata, headers);
            dispatch({
                type: IU_CMS_BANNER_ACTION_TYPE,
                payload: res,
            });
            return Promise.resolve(res);
        } catch (err) {
            return Promise.reject(err);
        }
    };
export const insertUpdateCmsSubheader_action = (SubheaderID, SubheaderName, ViewType, SocialType, Link, isPublish, isActive) =>
    async (dispatch) => {
        try {
            const mapdata = {
                UserID: sessionStorage.getItem('UserID'),
                SubheaderID: SubheaderID,
                SubheaderName: SubheaderName,
                ViewType: ViewType,
                SocialType: SocialType,
                Link: Link,
                isPublish: isPublish,
                isActive: isActive
            };
            const res = await axiosPost(IUCmsSubheaderUrl, mapdata, headers);
            dispatch({
                type: IU_CMS_SUBHEADER_ACTION_TYPE,
                payload: res,
            });
            return Promise.resolve(res);
        } catch (err) {
            return Promise.reject(err);
        }
    };

export const publishCmsContent_action = (MenuID, ContentID, isPublish) =>
    async (dispatch) => {
        try {
            const mapdata = {
                UserID: sessionStorage.getItem('UserIDSS'),
                MenuID: MenuID,
                ContentID: ContentID,
                isPublish: isPublish
            };
            const res = await axiosPost(PublishCmsContentUrl, mapdata, headers);
            dispatch({
                type: PUBLISH_CMS_CONTENT_ACTION_TYPE,
                payload: res,
            });
            return Promise.resolve(res);
        } catch (err) {
            return Promise.reject(err);
        }
    };

export const publishCmsMenu_action = (MenuID, isPublish) =>
    async (dispatch) => {
        try {
            const mapdata = {
                UserID: sessionStorage.getItem('UserIDSS'),
                MenuID: MenuID,
                isPublish: isPublish
            };
            const res = await axiosPost(PublishCmsMenuUrl, mapdata, headers);
            dispatch({
                type: PUBLISH_CMS_MENU_ACTION_TYPE,
                payload: res,
            });
            return Promise.resolve(res);
        } catch (err) {
            return Promise.reject(err);
        }
    };

export const publishCmsFooter_action = (FooterID, isPublish) =>
    async (dispatch) => {
        try {
            const mapdata = {
                UserID: sessionStorage.getItem('UserIDSS'),
                FooterID: FooterID,
                isPublish: isPublish
            };
            const res = await axiosPost(PublishCmsFooterUrl, mapdata, headers);
            dispatch({
                type: PUBLISH_CMS_FOOTER_ACTION_TYPE,
                payload: res,
            });
            return Promise.resolve(res);
        } catch (err) {
            return Promise.reject(err);
        }
    };
export const publishCmsBanner_action = (BannerID, isPublish) =>
    async (dispatch) => {
        try {
            const mapdata = {
                UserID: sessionStorage.getItem('UserID'),
                BannerID: BannerID,
                isPublish: isPublish
            };
            const res = await axiosPost(PublishCmsBannerUrl, mapdata, headers);
            dispatch({
                type: PUBLISH_CMS_BANNER_ACTION_TYPE,
                payload: res,
            });
            return Promise.resolve(res);
        } catch (err) {
            return Promise.reject(err);
        }
    };
export const publishCmsSubheader_action = (SubheaderID, isPublish) =>
    async (dispatch) => {
        try {
            const mapdata = {
                UserID: sessionStorage.getItem('UserID'),
                SubheaderID: SubheaderID,
                isPublish: isPublish
            };
            const res = await axiosPost(PublishCmsSubheaderUrl, mapdata, headers);
            dispatch({
                type: PUBLISH_CMS_SUBHEADER_ACTION_TYPE,
                payload: res,
            });
            return Promise.resolve(res);
        } catch (err) {
            return Promise.reject(err);
        }
    };

export const updateCmsContentStatus_action = (MenuID, ContentID, isactive) =>
    async (dispatch) => {
        try {
            const mapdata = {
                UserID: sessionStorage.getItem('UserIDSS'),
                MenuID: MenuID,
                ContentID: ContentID,
                isactive: isactive
            };
            const res = await axiosPost(updateCMSContentStatusUrl, mapdata, headers);
            dispatch({
                type: UPDATE_CMS_CONTENT_STATUS_ACTION_TYPE,
                payload: res,
            });
            return Promise.resolve(res);
        } catch (err) {
            return Promise.reject(err);
        }
    };
export const deleteCmsMenu_action = (MenuID) =>
    async (dispatch) => {
        try {
            const mapdata = {
                UserID: sessionStorage.getItem('UserIDSS'),
                MenuID: MenuID
            };
            const res = await axiosPost(deleteCMSMenuUrl, mapdata, headers);
            dispatch({
                type: DELETE_CMS_MENU_ACTION_TYPE,
                payload: res,
            });
            return Promise.resolve(res);
        } catch (err) {
            return Promise.reject(err);
        }
    };
export const deleteCmsStaticFiles_action = (MenuID, FileID) =>
    async (dispatch) => {
        try {
            const mapdata = {
                UserID: sessionStorage.getItem('UserIDSS'),
                MenuID: MenuID, FileID: FileID
            };
            const res = await axiosPost(deleteCMSStaticFilesUrl, mapdata, headers);
            dispatch({
                type: DELETE_CMS_STATIC_FILES_ACTION_TYPE,
                payload: res,
            });
            return Promise.resolve(res);
        } catch (err) {
            return Promise.reject(err);
        }
    };

export const insertUpdateCMSStaticUploads_action = (cmsUploadData) =>
    async (dispatch) => {
        try {
            const mapdata = {
                UserID: sessionStorage.getItem('UserIDSS'),
                cmsUploadData: cmsUploadData
            };
            const res = await axiosPost(insertUpdateCMSStaticUploadsUrl, mapdata, headers);
            dispatch({
                type: IU_CMS_STATIC_UPLOADS_ACTION_TYPE,
                payload: res,
            });
            return Promise.resolve(res);
        } catch (err) {
            return Promise.reject(err);
        }
    };